import {config} from "./config";
import {request} from "./request";

function getOpenProduct(data, cb, fail_cb) {
    request.get.call(this, config.apiList.openProducts, data, cb, fail_cb)
}


var openProductApi = {
    getOpenProduct: getOpenProduct,
}

export {openProductApi}